import React from "react";
import PropTypes from "prop-types";
import Header from "./Header";
import Body from "./Body";
import Footer from "./Footer";
import { pymSendHeight } from "../utils/handlePym";

const SUBTITLE_TEXT =
  "The Growth and Opportunity Fund is not required to reveal where it gets its money, or details about how it spends it. The fund generated $821,000 between 2014 and 2018, and spent $445,000";

const FOOTNOTE_TEXT =
  "Balance represents the total of the fund's balance and net assets at the end of each year. 2017 data is drawn from 2018 tax filings because the fund's 2017 filings were unavailable.";

class Main extends React.Component {
  componentDidMount() {
    // This is intended to fix bug where app is clipped at bottom
    // on initial load.
    pymSendHeight({ timeout: 500 });
    pymSendHeight({ timeout: 1000 });
  }

  componentDidUpdate() {
    // Because our app changes height based on displayed content, we
    // update the iframe height after DOM elements have been updated.
    pymSendHeight();
  }

  render() {
    const { data } = this.props;
    return (
      <div className="container__outer">
        <div className="container__inner">
          <Header headline="Follow the Money" subtitle={SUBTITLE_TEXT} />
          <Body data={data} />
          <Footer
            footnote={FOOTNOTE_TEXT}
            byline="Daniel Simmons Ritchie"
            source="Growth and Opportunity Fund form 990 tax filings from 2014-18."
            outlet="Spotlight PA"
            outletUrl="https://www.spotlightpa.org/"
          />
        </div>
      </div>
    );
  }
}

Main.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default Main;
